import React from 'react';

import * as ROUTES from '../../../../constants/routes';
import * as APP_CONST from '../../../../constants/appConsts';
import styles from './TableConfigs.module.css';
import './style.global.css';
import Icon from '../../../UI/Icon/Icon';
import Counter from '../../../UI/Counter/Counter';
import Spinner from '../../../UI/Spinner/Spinner';

const ProductCell = ({ row }) => (
  <div className={styles.FlexCell}>
    <div className={styles.CellLeft}>
      {row.productType === APP_CONST.PRODUCT_TYPE_SHOW ||
        row.productType === APP_CONST.PRODUCT_TYPE_EVENT ||
        row.productType === APP_CONST.PRODUCT_TYPE_VOUCHER ? (
        <div className={['show-wrapper', styles.InfoWrapper].join(' ')}>
          <div className={styles.ThumbnailBox}>
            <a href={
              row.productType === APP_CONST.PRODUCT_TYPE_SHOW
                ? `${ROUTES.SHOW}/${row.show.showId}`
                : row.productType === APP_CONST.PRODUCT_TYPE_EVENT
                  ? `${ROUTES.EVENT_ITEM}/${row.show.showId}`
                  : `${ROUTES.GIFTCARD}`
            }
              id={
                row.productType === APP_CONST.PRODUCT_TYPE_SHOW ||
                  row.productType === APP_CONST.PRODUCT_TYPE_EVENT
                  ? row.show.showId
                  : row.id
              }
              title={
                row.productType === APP_CONST.PRODUCT_TYPE_SHOW
                  ? row.movie.movieName
                  : row.productType === APP_CONST.PRODUCT_TYPE_EVENT
                    ? row.event.eventName
                    : row.product.productName
              }
            >
              <img
                className={styles.Thumbnail}
                src={
                  row.productType === APP_CONST.PRODUCT_TYPE_SHOW
                    ? row.movie.imagePath
                    : row.productType === APP_CONST.PRODUCT_TYPE_EVENT
                      ? row.event.thumbImage //row.original.event.thumbImage
                      : row.product.productImagePath
                }
                alt={
                  row.productType === APP_CONST.PRODUCT_TYPE_SHOW
                    ? row.movie.imageName
                    : row.productType === APP_CONST.PRODUCT_TYPE_EVENT
                      ? row.event.eventName
                      : row.product.productName
                }
              />
            </a>
          </div>
          <div className={styles.PreloadLinkWrapper}>
            <a
              href={
                row.productType === APP_CONST.PRODUCT_TYPE_SHOW
                  ? `${ROUTES.SHOW}/${row.show.showId}`
                  : row.productType === APP_CONST.PRODUCT_TYPE_EVENT
                    ? `${ROUTES.EVENT_ITEM}/${row.show.showId}`
                    : `${ROUTES.GIFTCARD}`
              }
              id={
                row.productType === APP_CONST.PRODUCT_TYPE_SHOW ||
                  row.productType === APP_CONST.PRODUCT_TYPE_EVENT
                  ? row.show.showId
                  : row.product.id
              }
              title={
                row.productType === APP_CONST.PRODUCT_TYPE_SHOW
                  ? row.movie.movieName
                  : row.productType === APP_CONST.PRODUCT_TYPE_EVENT
                    ? row.event.eventName
                    : row.product.productName
              }
              className={styles.Title}
            >
              {row.productType === APP_CONST.PRODUCT_TYPE_SHOW ? (
                <span>
                  {row.movie.movieName} {row.show.date}{' '}
                  {row.show.time}
                </span>
              ) : row.productType === APP_CONST.PRODUCT_TYPE_EVENT ? (
                <span>
                  {row.event.eventName} {row.show.date}{' '}
                  {row.show.time}
                </span>
              ) : (
                <span>{row.product.productName}</span>
              )}
            </a>
          </div>
        </div>
      ) : row.productType === APP_CONST.PRODUCT_TYPE_VOUCHER_ITEM ? (
        <div className="voucher-item-wrapper">{row.productName}</div>
      ) : (
        <div className="product-wrapper">
          {row.product.productName}
        </div>
      )}
    </div>
  </div>
);

const DescriptionCell = ({ row }) => (
  <div className={styles.FlexCell}>
    <div className={styles.HeaderInline}>Beschreibung</div>
    <div className={styles.Cell}>
      <span>{row.product.description}</span>
    </div>
  </div>
);

const QuantityCell = ({
  row,
  data: {
    onCounterChange,
    incCounterClicked,
    decCounterClicked,
    onCheckboxChange,
  },
}) => (
  <div className={styles.FlexCell}>
    <div className={styles.HeaderInline}>Anzahl</div>
    <div className={[styles.Counter, row.productType].join(' ')}>
      {row.product &&
        row.product.productOrderType !==
        APP_CONST.PRODUCT_ORDER_TYPE_OPTION &&
        !row.product.mandatory ? (
        <Counter
          value={row.amount}
          incClicked={e => incCounterClicked(e, row.key)}
          decClicked={e => decCounterClicked(e, row.key)}
          onChange={e => onCounterChange(e, row.key)}
        />
      ) : row.productType === APP_CONST.PRODUCT_TYPE_VOUCHER_ITEM ? (
        <div className={styles.Cell}>{row.count}</div>
      ) : (
        <div className={styles.Cell} />
      )}
    </div>
  </div>
);

const RemoveCell = ({ row, data: { onDeleteItem, isRemovingFromCart } }) => (
  <div className={styles.FlexCell}>
    <div className={styles.HeaderInline}>Löschen</div>
    <div className={[styles.Cell, styles.Cross].join(' ')}>
      {isRemovingFromCart[row.value] ? (
        <span>
          <Spinner type="small" />
        </span>
      ) : (
        <div>
          {row.productType !== 'showProduct' ||
            !row.product.mandatory ? (
            <span onClick={() => onDeleteItem(row.value)}>
              <Icon icon="cross" fontSize={22} className={styles.CrossIcon} />
            </span>
          ) : (
            <span />
          )}
        </div>
      )}
    </div>
  </div>
);

export const Product = {
  label: 'Beschreibung',
  accessor: 'product',
  headerClassName: styles.Header,
  renderCell: row => <ProductCell row={row} />,
  width: 600,
  className: styles.Column,
};

export const Description = {
  label: 'Bezeichnung',
  accessor: 'description',
  headerClassName: styles.Header,
  renderCell: row => <DescriptionCell row={row} />,
  width: 400,
  className: styles.Column,
};

export const Price = {
  label: 'Preis',
  accessor: 'price',
  renderCell: row => (
    <div className={styles.FlexCell}>
      <div className={styles.HeaderInline}>Einzelpreis</div>
      <div className={styles.Cell}>
        {row.productType === APP_CONST.PRODUCT_TYPE_SHOW ||
          row.productType === APP_CONST.PRODUCT_TYPE_EVENT ? (
          <span />
        ) : row.productType !== APP_CONST.PRODUCT_TYPE_VOUCHER_ITEM ? (
          <span>&euro;{row.product.price}</span>
        ) : (
          <span>&euro;{row.price}</span>
        )}
      </div>
    </div>
  ),
  headerClassName: styles.Header,
  width: 150,
  className: styles.Column,
};

export const Quantity = (
  incCounterClicked,
  decCounterClicked,
  onCounterChange,
  onCheckboxChange
) => {
  return {
    label: 'Anzahl',
    renderCell: row => (
      <div>
        {row.productType === APP_CONST.PRODUCT_TYPE_SHOW ||
          row.productType === APP_CONST.PRODUCT_TYPE_EVENT ? (
          <div />
        ) : (
          <QuantityCell
            row={row}
            data={{
              incCounterClicked,
              decCounterClicked,
              onCounterChange,
              onCheckboxChange,
            }}
          />
        )}
      </div>
    ),
    headerClassName: styles.Header,
    width: 160,
    className: styles.Column,
  };
};

export const Total = {
  label: 'Summe',
  accessor: 'totalPrice',
  renderCell: row => (
    <div className={styles.FlexCell}>
      <div className={styles.HeaderInline}>Positionssumme</div>
      <div className={styles.Cell}>
        <span>&euro;{row.value}</span>
      </div>
    </div>
  ),
  headerClassName: styles.Header,
  width: 150,
  className: styles.Column,
};

export const Remove = (onDeleteItem, isRemovingFromCart) => {
  return {
    label: '',
    accessor: 'key',
    renderCell: row => (
      <RemoveCell row={row} data={{ onDeleteItem, isRemovingFromCart }} />
    ),
    headerClassName: styles.Header,
    width: 70,
    className: styles.Column,
  };
};
